import { Component, OnInit } from '@angular/core';
import { SEOService } from '../services/seo.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})

export class BlogComponent implements OnInit {

  pageTitle = "Il Blog | Leone Lifestyle";
  desc = "La nuova era della nutrizione e del benessere"
  shareImg = "blog/masthead-blog.jpg";

  constructor(private seo: SEOService) {}

  ngOnInit() { 
    this.seo.updatePageTags(this.pageTitle, this.desc, this.shareImg);
  }

  // I NUOVI ARTICOLI VANNO INSERITI IN TESTA!
  articles = [
    {
      title: "GLICOGENOSI DI TIPO V UNA SPERANZA CONCRETA ARRIVA DALLA CHETOGENICA",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> MARTEDÌ 6 LUGIO 2021",
      section: "#DIETA CHETOGENICA",
      section_1: "#GLICOGENOSI",
      section_2: "#LEONELIFESTYLE",
      src: "assets/blog/glicogenosi-tipo-4-thumb.jpg",
      url: "blog/glicogenosi-tipo-4"
    },
    {
      title: "CHETOGENICA E TESTOSTERONE",
      author: "RICCARDO FERRERO LEONE - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> MERCOLEDÌ 26 MAGGIO 2021",
      section: "#DIETA CHETOGENICA",
      section_1: "#NUTRIZIONE CHETOGENICA",
      section_2: "#LEONELIFESTYLE",
      src: "assets/blog/chetogenica-e-testosterone-thumb.jpg",
      url: "blog/chetogenica-e-testosterone"
    },
    {
      title: "SVUOTIAMO LE TERAPIE INTENSIVE",
      author: "RICCARDO FERRERO LEONE - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> GIOVEDÌ 1 APRILE 2021",
      section: "#AUTOIMMUNITÀ",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/svuotiamo-le-terapie-intensive-thumb.jpg",
      url: "blog/svuotiamo-le-terapie-intensive"
    },
    {
      title: "CORPI CHETONICI E SALUTE CARDIOVASCOLARE",
      author: "RICCARDO FERRERO LEONE - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> GIOVEDÌ 11 MARZO 2021",
      section: "#SINDROME METABOLICA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/corpi-chetonici-e-salute-cardiovascolare-thumb.jpg",
      url: "blog/corpi-chetonici-e-salute-cardiovascolare"
    },
    {
      title: "BINGE EANTING: DIPENDENZA DA CIBO E NUTRIZIONE CHETOGENICA",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> DOMENICA 20 DICEMBRE 2020",
      section: "#SINDROME METABOLICA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/binge-thumb.jpg",
      url: "blog/binge-eating"
    },
    {
      title: "PERDITA DI PESO: LE DIETE A BASSO CONTENUTO DI CARBOIDRATI SONO EFFICACI?",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> SABATO 13 GIUGNO 2020",
      section: "#PERDITA DI PESO",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/diete-low-carb-thumb.jpg",
      url: "blog/diete-low-carb"
    },
    {
      title: "SINDROME METABOLICA",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> SABATO 18 LUGLIO 2020",
      section: "#SINDROME METABOLICA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/sindrome-metabolica-thumb.jpg",
      url: "blog/sindrome-metabolica"
    },
    {
      title: "FERTILITA’ E NUTRIZIONE CHETOGENICA",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> LUNEDÌ 20 APRILE 2020",
      section: "#GINECOLOGIA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/fertilita-thumb.jpg",
      url: "blog/fertilita"
    },
    {
      title: "IPERTENSIONE: IL RUOLO DI UNA NUTRIZIONE A BASSO CONTENUTO DI CARBOIDRATI",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> SABATO 18 APRILE 2020",
      section: "#SINDROME METABOLICA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/ipertensione-thumb.jpg",
      url: "blog/ipertensione"
    },
    {
      title: "LA SALUTE DEI NOSTRI POLMONI E LA NUTRIZIONE CHETOGENICA",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> DOMENICA 5 APRILE 2020",
      section: "#RESPIRAZIONE",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/la-salute-dei-nostri-polmoni-thumb.jpg",
      url: "blog/la-salute-dei-nostri-polmoni"
    },
    {
      title: "ADA: FINALMENTE UNA LUCE IN FONDO AL TUNNEL?",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> GIOVEDÌ 2 APRILE 2020",
      section: "#SINDROME METABOLICA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/ada-thumb.jpg",
      url: "blog/ada"
    },
    {
      title: "STABILIZZAZIONE DELL’UMORE",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> VENERDÌ 27 DICEMBRE 2019",
      section: "#NEUROLOGIA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/stabilizzazione-dell-umore-thumb.jpg",
      url: "blog/stabilizzazione-dell-umore"
    },
    {
      title: "COME DIMAGRIRE",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> GIOVEDÌ 19 DICEMBRE 2019",
      section: "#PERDITA DI PESO",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/come-dimagrire-thumb.jpg",
      url: "blog/come-dimagrire"
    },
    {
      title: "L’ORGANO ADIPOSO ED IL SUO RUOLO FONDAMENTALE",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> MERCOLEDÌ 18 DICEMBRE 2019",
      section: "#PERDITA DI PESO",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/organo-adiposo-thumb.jpg",
      url: "blog/organo-adiposo"
    },
    {
      title: "MALATTIA RENALE CRONICA E DIETE CHETOGNICHE O LOW-CARB",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> LUNEDÌ 16 DICEMBRE 2019",
      section: "#SINDROME METABOLICA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/malattia-renale-cronica-thumb.jpg",
      url: "blog/malattia-renale-cronica"
    },
    {
      title: "BENEFICI METABOLICI UNICI",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> VENERDÌ 13 DICEMBRE 2019",
      section: "#SINDROME METABOLICA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/benefici-metabolici-thumb.jpg",
      url: "blog/benefici-metabolici"
    },
    {
      title: "EPILESSIA E NON SOLO",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> MERCOLEDÌ 11 DICEMBRE 2019",
      section: "#NEUROLOGIA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/epilessia-e-non-solo-thumb.jpg",
      url: "blog/epilessia-e-non-solo"
    },
    {
      title: "PREECLAMPSIA (GESTOSI) COMPLICE L’IPERGLICEMIA",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> MERCOLEDÌ 11 DICEMBRE 2019",
      section: "#SINDROME METABOLICA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/preeclampsia-thumb.jpg",
      url: "blog/preeclampsia"
    },
    {
      title: "DIABETE DI TIPO 2 E CHETOGENICA",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> SABATO 7 DICEMBRE 2019",
      section: "#SINDROME METABOLICA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/diabete-tipo-2-thumb.jpg",
      url: "blog/diabete-tipo-2"
    },
    {
      title: "OVAIO POLICISTICO",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> LUNEDÌ 2 DICEMBRE 2019",
      section: "#GINECOLOGIA",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/ovaio-policistico-thumb.jpg",
      url: "blog/ovaio-policistico"
    },
    {
      title: "PATOLOGIE REUMATICHE",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> LUNEDÌ 2 DICEMBRE 2019",
      section: "#AUTOIMMUNITÀ",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/patologie-reumatiche-thumb.jpg",
      url: "blog/patologie-reumatiche"
    },
    {
      title: "TIROIDE E CHETOGENICA: UN PROBLEMA O UNA SOLUZIONE?",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> GIOVEDÌ 14 NOVEMBRE 2019",
      section: "#AUTOIMMUNITÀ",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/tiroide-e-chetogenica-thumb.jpg",
      url: "blog/tiroide-e-chetogenica"
    }
  ]
}
